var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ComponentSelectField',{attrs:{"errorMessages":_vm.errorMessages,"name":_vm.name,"schema":Object.assign({}, _vm.schema,
    {fieldOptions: Object.assign({}, _vm.schema.fieldOptions,
      {componentTypeName: 'forms'})}),"disabled":_vm.disabled,"environmentVariables":_vm.environmentVariables},model:{value:(_vm.syncValue),callback:function ($$v) {_vm.syncValue=$$v},expression:"syncValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }